import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { PermissionsService } from '~app/services/permissions.service';


export const NavGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
	inject(PermissionsService).canNavigate(route, state);
